import { ref } from "vue";
import { defineStore } from "pinia";

export const useHistory = defineStore('history', () => {
    let history = ref([]);
    let animation = ref("slide-right");
    let firstLoad = ref(true);

    function updateAnimation(animationName) {
        animation.value = animationName;
    }

    function updateAnimationOnce(animationName) {
        let previousAnimation = animation.value;
        animation.value = animationName;
        setTimeout(() => {
            animation.value = previousAnimation;
        }, 200);
    }

    return {
        history,
        animation,
        firstLoad,
        updateAnimation,
        updateAnimationOnce
    };
});